import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react"; // Added useState
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { DetailsPageLayout } from "../components/layouts/DetailsPageLayout";
import { splitDocument as splitDocumentApi } from "../features/documents/api/documentsApi"; // Added API import
import { BreadcrumbNav } from "../features/documents/components/DocumentDetails/BreadcrumbNav";
import { DocumentHeader } from "../features/documents/components/DocumentDetails/DocumentHeader";
import { DocumentSidebar } from "../features/documents/components/DocumentDetails/DocumentSidebar";
import { PreviewTab } from "../features/documents/components/DocumentDetails/PreviewTab";
import { SplitDocumentModal } from "../features/documents/components/SplitDocumentModal"; // Added modal import
import { selectDocumentById } from "../features/documents/store/documentsSelectors";
import { RootState } from "../store/rootReducer";
import { fetchInsightsStart } from "../features/insights";
// Removed snackbar import
export const DocumentDetailsPage: React.FC = () => {
  const [isSplitModalOpen, setIsSplitModalOpen] = useState(false); // Modal state
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const { id, propertyId, documentId } = useParams<{
    id?: string;
    propertyId?: string;
    documentId?: string;
  }>();
  const document = useSelector((state: RootState) =>
    selectDocumentById(state, documentId || id || "")
  );

  const dispatch = useDispatch();
  useEffect(() => {
    if (!document) return; // Added check for documentId
    dispatch(fetchInsightsStart(document.id));
  }, [dispatch, document]);

  const handleOpenSplitModal = () => setIsSplitModalOpen(true);
  const handleCloseSplitModal = () => setIsSplitModalOpen(false);

  const handleSplitSubmit = async (splits: any[]) => {
    // Using 'any' temporarily, should use SplitDefinition
    // Using 'any' temporarily, should use SplitDefinition
    if (!document) return;
    try {
      const result = await splitDocumentApi(document.id, splits);
      console.log("Split initiated:", result.message); // Log success
      handleCloseSplitModal(); // Close modal on success
    } catch (error: any) {
      console.error("Failed to split document:", error); // Log error
      // Re-throw to keep the error state in the modal
      throw error;
    }
  };

  if (!document) {
    return (
      <Box sx={{ mt: 4 }}>
        <Typography color="error">Document not found</Typography>
      </Box>
    );
  }

  // TODO: Pass handleOpenSplitModal to DocumentHeader
  const headerContent = (
    <>
      <BreadcrumbNav document={document} propertyId={propertyId} />
      {/* Need to modify DocumentHeader to accept and use onSplitClick */}
      <DocumentHeader document={document} onSplitClick={handleOpenSplitModal} />
    </>
  );

  const mainContent = (
    <Box
      sx={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}
    >
      <Box sx={{ display: "flex", flex: 1, minHeight: 0 }}>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            borderRight: isMobile ? 0 : 1,
            borderBottom: isMobile ? 1 : 0,
            borderColor: "divider",
          }}
        >
          <Box
            sx={{ display: "flex", flexDirection: "column", height: "100%" }}
          >
            <DocumentSidebar document={document} />
          </Box>
        </Box>
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
          <PreviewTab document={document} />
        </Box>
      </Box>
    </Box>
  );

  return (
    <>
      <DetailsPageLayout
        headerContent={headerContent}
        mainContent={mainContent}
      />
      {/* Render Modal */}
      <SplitDocumentModal
        open={isSplitModalOpen}
        onClose={handleCloseSplitModal}
        document={document}
        onSubmit={handleSplitSubmit}
      />
    </>
  );
};
